<template>
  <div
    class="TradesPreview--Wrap"
    :class="[{ 'is-light': mode === 'light' }, { 'is-dark': mode === 'dark' }]"
  >
    <span class="TradesPreview--Link" v-html="content" ref="tradesLink" @click="tradesLinkClick" />
    <div class="TradesPreview" ref="TradesPreview" v-click-outside="hidePreview">
      <div class="TradesPreview--Content" v-if="TradesData" v-html="TradesData"></div>
    </div>
  </div>
</template>
<script>
import coreLibrary from "../../../core/helpers/CoreLibrary";
import anime from 'animejs';
import ClickOutside from 'vue-click-outside';
import * as actions from "../../Config/ApiUrl";
const OFFSET = 20;
const isMobile = window.innerWidth < 500;
export default {
  extends: coreLibrary,
  props: {
    content: {
      default: '-',
    },
    changes: {
      default: null,
    },
    mode: {
      type: String,
      default: 'dark',
      validator: function (value) {
        // The value must match one of these strings
        return ['light', 'dark'].indexOf(value) !== -1;
      },
    },
  },
  data() {
    return {
      TradesData: null,
      lastClicked: 0,
    }
  },
  directives: {
    ClickOutside,
  },
  methods: {
    tradesLinkClick(){
      this.lastClicked = Math.round(new Date().getTime() / 1000);
      this.showPreview();
    },
    showPreview(){
      const elementRect = this.$refs.tradesLink.getBoundingClientRect();

      const spaceAbove = elementRect.top;
      const spaceBelow = window.innerHeight - elementRect.bottom;

      const element = this.$refs.TradesPreview;
      if (element.classList.contains('is-visible')) return;
      $('.TradesPreview.is-visible').each(function(){
        this.classList.remove('is-visible');
        this.parentNode.classList.remove('is-child-visible');
        anime({
          targets: this,
          translateY: [0, '20%'],
          translateX: 0,
          opacity: [1, 0],
          easing: 'spring(1, 80, 10, 4)',
        });
      });
      element.classList.add('is-visible');
      element.parentNode.classList.add('is-child-visible');
      const { y, x, width: linkWidth, height: linkHeight } = this.$refs.tradesLink.getBoundingClientRect();
      const { width: elementWidth } = element.getBoundingClientRect();
      if (spaceBelow < spaceAbove) {
        //console.log('above');
        anime({
          targets: element,
          left: isMobile
            ? ['50%', '50%']
            : [x - (elementWidth - linkWidth) / 2, x - (elementWidth - linkWidth) / 2],
          top: 'auto',
          bottom: window.innerHeight - y + OFFSET,
          //translateY: ['50%', 0],
          translateX: isMobile ? ['-50%', '-50%'] : 0,
          opacity: [0, 1],
          easing: 'spring(1, 80, 12, 4)',
        });
      } else {
        ///console.log('below');
        anime({
          targets: element,
          left: isMobile
            ? ['50%', '50%']
            : [x - (elementWidth - linkWidth) / 2, x - (elementWidth - linkWidth) / 2],
          top: y + linkHeight + OFFSET,
          bottom: 'auto',
          //translateY: ['50%', 0],
          translateX: isMobile ? ['-50%', '-50%'] : 0,
          opacity: [0, 1],
          easing: 'spring(1, 80, 12, 4)',
        });
        element.style.bottom = 'auto';
      }

      let data = JSON.parse(this.changes);
      let length = data.length;
      let start = 0;
      let html = '<table style="width: 100%">';
      data.sort((a,b)=> (a.size < b.size ? 1 : -1));
      for (let x = start; x < length; x++){
        let total = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'EUR' }).format(data[x].size);
        let change = '';
        let changeClass = '';
        if (data[x].change){
          change = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'EUR' }).format(data[x].change);
          if (data[x].change > 0){
            change = "+" + change;
            changeClass = 'up';
          }
        }
        if (x < 12 || data[x].change){
          html += '<tr><td class="odds">' + data[x].price + '</td><td>' + change + '</td><td class="' + changeClass +'">' + total + '</td></tr>';
        }
      }
      html += '</table>';
      this.TradesData = html;
    },
    hidePreview() {
      let current = Math.round(new Date().getTime() / 1000);
      if ((current - this.lastClicked) < 2){
        return false;
      }
      const element = this.$refs.TradesPreview;
      if (!element.classList.contains('is-visible')) return;
      element.classList.remove('is-visible');
      element.parentNode.classList.remove('is-child-visible');
      const { y, x, width: linkWidth } = this.$refs.tradesLink.getBoundingClientRect();
      const { width: elementWidth } = element.getBoundingClientRect();
      anime({
        targets: this.$refs.TradesPreview,
        left: isMobile
          ? ['50%', '50%']
          : [x - (elementWidth - linkWidth) / 2, x - (elementWidth - linkWidth) / 2],
        bottom: window.innerHeight - y + OFFSET,
        translateY: [0, '20%'],
        translateX: isMobile ? ['-50%', '-50%'] : 0,
        opacity: [1, 0],
        easing: 'spring(1, 80, 10, 4)',
      });
    },
  },
};
</script>
<style lang="scss">
.TradesPreview--Wrap {
  position: relative;
  display: inline;
  text-align: left;
  &.is-child-visible {
    background: #c6c6c6;
  }
  .TradesPreview {
    width: clamp(250px, 30vw, 410px);
    opacity: 0;
    z-index: 1;
    position: fixed;
    background-color: white;
    border-radius: 8px;
    box-shadow: 0 0 60px 0 rgba(black, 0.15);
    will-change: auto;
    left: 0;
    //bottom: 0;
    opacity: 0;
    padding: 10px;
    pointer-events: none;
    color: black;
    > * {
      will-change: auto;
    }
    .first-row {
      background-color: #dddddd;
    }
    &.is-visible {
      pointer-events: all;
    }
    .TradesPreview--Person {
      display: flex;
      align-items: center;
    }
    .TradesPreview--Content {
      font-size: 0.85rem;
      margin-top: 20px;

      .odds {
        padding-left: 5px !important;
      }
    }
    .TradesPreview--Link {
      text-decoration: underline;
    }
    .up {
      color: #81bf5c;
    }
    .down {
      color: #bf5c5c;
    }
  }
}
[theme="dark"]{
  .TradesPreview {
    background-color: #353a47;
    .odds {
      color: white;
    }
    .first-row {
      background-color: #292c33;
      td {
        padding-top: 5px !important;
        padding-bottom: 5px !important;
      }
    }
    .history-link {
      td {
        padding-top: 5px !important;
      }
      a {
        color: #72798f !important;
        font-size: 0.9em;
      }
      a:hover {
        color: #878fa8 !important;
      }
    }
  }
  .TradesPreview--Wrap.is-child-visible {
    background: #464e60 !important;
    color: #fff;
  }
}
</style>